
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/veranstaltung-vorschlagen",
      function () {
        return require("private-next-pages/veranstaltung-vorschlagen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/veranstaltung-vorschlagen"])
      });
    }
  